<template>
  <div class="ImportEnt">
  </div>
</template>
<script>
  // import modal from 'modal'
   export default {
   	data(){
   		return {
   			
   		}
   	},
   	methods:{
   	  
   	},
   	mounted(){

   		// this.showModal("提示","无关联企业");
   	}
    // mixins:[modal]
   }
</script>


// WEBPACK FOOTER //
// ImportEnt.vue?9319adf6